export default "__VITE_ASSET__Cra0o309__"